import { createStyles } from "antd-style";

import { generateFontSizeCssRules } from "./html-transport";
import { sanitizeHtml } from "./sanitize-html";

import type { AvE2EProps } from "../types";

type Props = {
  htmlString: string;
  allowTextFormattingStyles?: boolean;
  openLinksInNewTab?: boolean;
} & AvE2EProps;

const useStyles = createStyles(({ css, token }) => ({
  root: css`
    a,
    a * {
      color: ${token.colorLink} !important;
    }

    .av-sanitized-color-gray {
      color: #8c8c8c;
    }

    .av-sanitized-color-red {
      color: #ff4d4f;
    }

    .av-sanitized-color-gold {
      color: #faad14;
    }

    .av-sanitized-color-green {
      color: #52c41a;
    }

    .av-sanitized-color-blue {
      color: #1677ff;
    }

    .av-sanitized-color-purple {
      color: #722ed1;
    }

    ${generateFontSizeCssRules()}
  `,
}));

export function SanitizedHTML({
  testIdPrefix,
  htmlString,
  allowTextFormattingStyles,
  openLinksInNewTab,
}: Props) {
  const { styles } = useStyles();

  return (
    <div
      className={styles.root}
      data-testid={`${testIdPrefix}-sanitized-html`}
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(htmlString, openLinksInNewTab, allowTextFormattingStyles),
      }}
    />
  );
}
